export default {
  setEvents: (state, data) => {
    state.original = data.evOrig;
    state.events = data.ev;
    state.ready = true;
  }
};
